// Application layer
/**
 * Caso de uso: listar facturas
 * ------------------------------------------------
 * Responsabilidad:
 * - Validar filtros
 * - Aplicar reglas de negocio de lectura
 * - Delegar persistencia al repositorio
 */

import { ventasxfacturaRepository } from "../infrastructure/supabase/repository/ventasxfacturas.repository.js";

export async function listarVentasUseCase(filtros) {
  return await ventasxfacturaRepository.listar(filtros);
}
